<script>
import {computed, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        value: [String, Number],
        readonly: Boolean,
        label: String,
        hideDetails: [String, Boolean],
        priceFormat: Boolean,
        dateFormat: Boolean,
        paySlipFormat: Boolean,
        hideChip: Boolean,
        disableChipOutlined: Boolean,
        disableInline: Boolean,
        chipColor: String,
        large: Boolean,
        clazz: String,
        bold: Boolean,
        type: String,
        clickable: {
            type: Boolean,
            default: false
        },
        length: {
            type: Number,
            default: null
        },
        showPlaceHolder: Boolean,
        placeHolder: String,
        textarea: Boolean,
        rules: Array,
    },
    emits: ["save", "open"],
    setup(props, {emit}) {
        const {priceFormat, formatedDate} = useSharedMethod();

        const valeur = ref(null);

        const formattedValue = computed(() => {
            if (props.showPlaceHolder)
                return props.placeHolder;

            if (props.priceFormat)
                return priceFormat(valeur.value)

            if(props.dateFormat) {
                return formatedDate(valeur.value);
            }


            return valeur.value;
        });

        function save() {
            if (valeur.value === null || valeur.value === undefined) {
                valeur.value = 0.0;
            }

            emit('input', valeur.value);
            emit('save', valeur.value);
        }

        function open() {
            if (valeur.value === 0)
                valeur.value = null;
            emit('open');
        }

        watch(() => props.value, () => {
            if (props.value !== null && props.value !== undefined)
                valeur.value = props.value;
        }, {immediate: true});

        return {
            valeur,
            formattedValue,
            save,
            open
        }
    }
}
</script>

<template>
    <div>
        <w-inline-text
            v-if="readonly"
            :text="formattedValue"
            :disable-inline="disableInline"
            :bold="bold"
            :clazz="clazz"
            :clickable="clickable"
            :length="length"
        />
        <v-edit-dialog
            v-if="!readonly"
            :return-value.sync="valeur"
            :large="large"
            @open="open"
            @save="save"
        >
            <w-inline-text
                v-if="hideChip"
                :disable-inline="disableInline"
                :text="formattedValue"
                :bold="bold"
                :clazz="clazz"
                :clickable="clickable"
                :length="length"
                icon="mdi-pencil"
            />
            <w-chip
                v-else
                :outlined="!disableChipOutlined"
                :color="chipColor"
                icon="mdi-pencil"
                :text="formattedValue !== null && formattedValue !== undefined && formattedValue !== '' ? formattedValue : '  '"
            />
            <template v-slot:input>
                <div v-if="label">{{ label }}</div>
                <v-textarea
                    v-if="textarea"
                    v-model="valeur"
                    ref="textareaRef"
                    dense
                    :readonly="readonly"
                    :hide-details="hideDetails"
                />
                <w-date-picker
                    v-else-if="dateFormat"
                    v-model="valeur"
                    :readonly="readonly"
                />
                <v-text-field
                    v-else
                    v-model="valeur"
                    auto-focus
                    dense
                    :type="type"
                    :readonly="readonly"
                    :hide-details="hideDetails"
                />
            </template>
        </v-edit-dialog>

        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>